import React from "react";
import logo from "~/assets/img/logos/unik-logo.png";

const LoginLogo = () => {
  return (
    <div className="row">
      <div className="col-12 mt-3 mb-2 text-center">
        <img className="img-fluid unik-logo" src={logo} alt="Uniksystem" />
      </div>
    </div>
  );
};

export default LoginLogo;
